import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import GeneralHandler from '../../modules/General';
import {setSetting} from '../../actions/General.js';
import TimeAgo from 'react-timeago'
import General from '../../helpers/General.js';
import moment from 'moment';

class Events extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading:true,
            events:[]
        }


    }

    componentWillMount() {
        GeneralHandler.fetchGeneral().then(() => {
            axios.get('/events/emails').then(res => {
                this.setState({isLoading:false,events:res.data});
            });

        });


    }

    render() {
        if(this.state.isLoading) {
            return <Loading error={false} />
        }

        return (
            <div className="full-height">
                <Helmet title="Events | Crall.io" />
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-list"></i> Events</span>
                </div>

                <div className="page-content">

                <OptionColumn title="Emails" description="List of the last 500 e-mails">
                        <div className="col-sm-12">
                                <table className="table table-striped">
                                    <tbody>
                                        {this.state.events.map(event => {
                                            return (
                                                <tr key={event.id}>
                                                    <td>
                                                        <span dangerouslySetInnerHTML={{__html: event.text}}></span>&nbsp;
                                                        {moment(General.toLocalTime(event.created_at)).fromNow()}
                                                    </td>
                                                </tr>);
                                        })}
                                    </tbody>
                                </table>
                        </div>
                </OptionColumn>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setSetting},dispatch)
}


Events = connect(mapStateToProps,mapDispatchToProps)(Events);
export default Events;


// WEBPACK FOOTER //
// ./containers/events/events.js